import { Header, SpaceBetween } from '@cloudscape-design/components';
import PLCButton from 'features/plc/components/PLCButton';
import {
  PLC_PATHS,
  PRESS_MODE,
  TUNING_MODE_LABELS,
} from 'features/plc/contracts/pressHMI.schema';
import { usePLCValue, usePressTitle } from 'features/plc/providers/PLCProvider';
import React from 'react';

function TuningHeader() {
  const pressTitle = usePressTitle();
  const tuningMode = usePLCValue(PLC_PATHS.cmd.tuningRecipe.mode);
  const cycleRunning = usePLCValue(PLC_PATHS.status.cycleRunning);
  const stageLabel = cycleRunning
    ? (TUNING_MODE_LABELS[tuningMode] || `Unknown Tuning Mode (${tuningMode ?? '--'})`)
    : 'Tuning Idle';

  return (
    <Header
      variant="h1"
      actions={(
        <SpaceBetween direction="horizontal" size="xs">
          <PLCButton
            path={PLC_PATHS.cmd.pressMode}
            value={PRESS_MODE.NONE}
            variant="primary"
          >
            Disable tuning mode
          </PLCButton>
        </SpaceBetween>
      )}
    >
      {`${pressTitle} - ${stageLabel}`}
    </Header>
  );
}

export default TuningHeader;
